import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { type SessionStateContextType } from '@apps/web/context/session_state_provider';
import { modeStore } from '@apps/web/lib/mode_store';
import { type User } from '@libraries/typescript/api_client';

export function requirePlatformAdmin(context: {
    readonly sessionState: Pick<SessionStateContextType, 'session'> | null;
    readonly user: Pick<User, 'admin'> | null;
}): void {
    if (!context.sessionState?.session || context.user?.admin !== true) {
        throw redirect({ to: '/home' });
    }
}

export const Route = createFileRoute('/_app/(agent)')({
    beforeLoad: ({ context }) => {
        modeStore.activate();
        requirePlatformAdmin(context);
    },
    onLeave: modeStore.deactivate,
    component: AgentDebugLayout,
});

function AgentDebugLayout() {
    // AppLayout pins the product shell with `fixed inset-0 h-svh`. This
    // page is outside that shell, so `h-full` on the child would collapse
    // to content height (html/body/#root have no height).
    return (
        <div
            className="bg-background fixed inset-0 flex h-svh min-h-0 flex-col overflow-hidden"
            data-testid="agent-debug-shell"
        >
            <Outlet />
        </div>
    );
}
